var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LevellingPageShell',{attrs:{"title":"Job Mapping","icon":"mdi-file-tree-outline"}},[_c('LevellingReports',_vm._g(_vm._b({},'LevellingReports',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }